import React from 'react';
import Form from 'components/form';
import useCurrentSurfacePermissions from 'components/canvas/hooks/use-current-surface-permissions';
import { useTranslation } from 'i18n';
import { Header } from 'routes/surface/components/node-modal-form/style';
import {
  ProtocolNodeRepresentation,
  NameTextInput,
  TextInput,
  ProtocolNodeWrapper,
} from 'routes/surface/components/node-modal-form/components/protocol-node-modal/components/protocol-node-form/style';
import { object, string } from 'yup';
import { NodeModalInput } from 'types';
import { SurfaceProtocolNode } from 'graphql/types';
import useCanCreateOrEditSurfaceNode from 'routes/surface/components/node-modal-form/hooks/use-can-create-or-edit-surface-node';
import { isMobile } from 'react-device-detect';

const Checkbox = ({ label, value, onChange }) => {
  return (
    <label>
      <input type="checkbox" checked={value} onChange={onChange} />
      {label}
    </label>
  );
};

export interface ProtocolNodeFormProps {
  onSubmit: any;
  onCancel: Function;
  data: NodeModalInput<SurfaceProtocolNode>;
}

function createValidationSchema(t) {
  return function () {
    return object().shape({
      name: string().required(t('name is required')),
    });
  };
}

function ProtocolNodeForm({ data, onSubmit, onCancel }: ProtocolNodeFormProps) {
  const { t } = useTranslation();

  const validationSchema = React.useMemo(createValidationSchema(t), []);

  const nameInput = React.useRef<any>(null);

  const mailInput = React.useRef<any>(null);
  const commentInput = React.useRef<any>(null);

  const {
    canCreateOrEdit,
    isUpdate,
    cannotEdit,
  } = useCanCreateOrEditSurfaceNode(data);

  const submitLabel = isUpdate
    ? t('Update placeholder')
    : t('Insert placeholder');

  function isNameInputAutoFocused() {
    if (isUpdate) {
      return isMobile ? false : true;
    }

    return true;
  }

  React.useEffect(() => {
    setTimeout(() => nameInput.current.focus(), 200);
  }, []);

  const [isShared, setSharing] = React.useState<boolean>(false);

  const handleChangeOne = () => {
    setSharing(!isShared);
  };

  return (
    <Form
      initialValues={data}
      validationSchema={validationSchema}
      onSubmit={onSubmit}>
      {(form) => (
        <>
          <Header>
            <Form.Button label={t('Close')} onClick={onCancel} secondary />
            {canCreateOrEdit && (
              <Form.SubmitButton
                label={submitLabel}
                onClick={form.handleSubmit}
              />
            )}
          </Header>
          <ProtocolNodeWrapper>
            <NameTextInput
              ref={nameInput}
              name="name"
              placeholder={t('Name of protocol node')}
              disabled={cannotEdit}
              noBorder
              secondary
              autoFocus={isNameInputAutoFocused()}
            />
            <ProtocolNodeRepresentation />

            {!data.id && (
              <>
                {' '}
                <>
                  <Checkbox
                    label={t('Fremdupload (i)')}
                    value={isShared}
                    onChange={handleChangeOne}
                  />
                </>
                {isShared && (
                  <>
                    <TextInput
                      ref={mailInput}
                      name="shareEmail"
                      placeholder={t('E-mailaddresse')}
                      disabled={cannotEdit}
                      noBorder
                      secondary
                      // autoFocus={isNameInputAutoFocused()}
                    />
                    <TextInput
                      ref={commentInput}
                      name="comment"
                      placeholder={t('Kommentar')}
                      disabled={cannotEdit}
                      noBorder
                      secondary
                      // autoFocus={isNameInputAutoFocused()}
                    />
                  </>
                )}
              </>
            )}

            {data.uploader && (
              <>
                <div>Email: {data.uploader}</div>
                <div>Kommentar: {data.uploadComment}</div>
                {data.contains && (
                  <div>Erstellt am: {data.contains.createdAt}</div>
                )}
                {<div>KEY : {data.id}</div>}
                {/* {<div>KEY : {JSON.stringify(Object.keys(data.contains))}</div>}
              {<div>KEY : {JSON.stringify((data.contains))}</div>} */}
              </>
            )}
          </ProtocolNodeWrapper>
        </>
      )}
    </Form>
  );
}

export default ProtocolNodeForm;
